import React, {Component} from "react";
import  {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    Image,
    KeyboardAvoidingView, Alert, Keyboard,
} from "react-native";

const {width: SCREEN_WIDTH} = Dimensions.get("window");

import HMTextView from "../../../customviews/HMTextView";
import {moderateScale} from "../../../tools/Scaling";
import Colors, {colorDark, colorPrimary} from "../../../tools/Colors";
import HMActionBarSatia from "../../../customviews/HMActionBarSatia";
import {typeExport} from "../../../redux/store/type";
import PathFile from "../../../assets/PathFile/index";
import * as NavigationService from "../../../redux/NavigationService";
import {Tools} from "../../../tools/Tools";
import HMIcon from "../../../customviews/HMIcon";


let container = null;

export default class ContactUsScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        let item = props.navigation && props.route && props.route.params && props.route.params.item ? props.route.params.item : null;
        this.state = {

            modalHeight: 0,
            // let item = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params.item : this.props.item;

            list: item && item.details && item.details.length > 0 ? item.details : [
                {
                    name: "1547",
                    link: "1547",
                    type: 'phone',
                    image: PathFile.image.telephone,
                    imageWeb:typeExport._baseUrlImageAssets + "telephone.png",
                },
                {
                    name: "08633805",
                    link: "08633805",
                    type: 'phone',
                    image: PathFile.image.telephone,
                    imageWeb:typeExport._baseUrlImageAssets + "telephone.png",
                },
                {
                    name: "Satia.co",
                    link: "Satia.co",
                    image: PathFile.image.www,
                    imageWeb: typeExport._baseUrlImageAssets +"www.png",

                },
                {
                    name: "Satianet",
                    link: "https://www.instagram.com/satianet/",
                    image: PathFile.image.instagram,
                    imageWeb: typeExport._baseUrlImageAssets +"instagram.png",

                },
                {
                    name: "@Satianet",
                    link: "https://t.me/satianet",
                    image: PathFile.image.telegram,
                    imageWeb:typeExport._baseUrlImageAssets + "telegram.png",

                }],
            item: item
        };

    }

    componentDidMount() {

    }

    static ShowMessageBack(text) {

    }

    componentWillUnmount() {

    }


    render() {
        return (

            <View style={{flex: 1,}}>
                <HMActionBarSatia
                    props={this.props} statusBarTransparent
                    text={"تماس با ما"}

                    //  text={i18n.t('constant.Information')}
                    // menu={!checkLogin}
                    back
                    headerVisibility more_menu
                    onBackPress={() => this.props.navigation.pop()}

                />
                <ScrollView>
                    <View style={{
                        margin: moderateScale(8),
                        //   marginVertical:moderateScale(8),
                        padding: moderateScale(6),
                        borderRadius: moderateScale(10),
                        backgroundColor: Colors.white
                    }}>
                        <FlatList
                            //   inverted={true}
                            keyboardShouldPersistTaps="handled"

                            style={{
                                //height: moderateScale(40),
                                marginTop: moderateScale(4),
                                marginBottom: moderateScale(4),

                                alignSelf: 'center'
                            }}
                            //  data={data.results.all_categories}
                            //  data={[{id: 1, name: 'متوفی'}, {id: 2, name: 'شعید'}]}
                            data={this.state.list}

                            renderItem={({item, index}) => {

                                return <TouchableOpacity
                                    onPress={() => {
                                        Tools.GoLink(item.link, item.type)
                                    }
                                    }
                                    style={{
                                      //  width: (typeExport._WIDTH / 3) - moderateScale(6),
                                        paddingVertical: moderateScale(4),
                                        paddingHorizontal: moderateScale(4),
                                        marginVertical: moderateScale(3),
                                        //   backgroundColor: this.state.indexSelectType == index ? Colors.colorPrimary : Colors.red,
                                        //  borderColor: this.state.indexSelectType == index ? Colors.white : Colors.colorPrimary,
                                        // borderWidth: moderateScale(1),
                                        // borderRadius: moderateScale(10),
                                        // marginHorizontal: moderateScale(2),
                                        alignItems: 'center',
                                        // justifyContent: 'space-between',
                                        flexDirection: 'row'
                                    }}
                                >

                                    {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                                    {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}

                                    <Image
                                        source={item.image}
                                       // resizeMode="stretch"
                                        style={{width: moderateScale(28), height: moderateScale(28)}}/>
                                    {/*     <Icon name={item.image} style={{
                                        color: colorDark,
                                        fontSize: moderateScale(24),
                                        //padding:moderateScale(4),
                                        // alignSelf: "center",
                                    }}/>*/}
                                    <HMTextView text={item.name} type={"bold"}
                                                style={{
                                                    color: Colors.blue,
                                                    marginHorizontal: moderateScale(8),
                                                    fontSize: moderateScale(14),
                                                    lineHeight: moderateScale(14) * moderateScale(0.75),
                                                    paddingTop: (moderateScale(14) + (moderateScale(14) / 2)) - (moderateScale(14) * moderateScale(0.75)),
                                                    //marginTop: moderateScale(2),
                                                    //  backgroundColor:Colors.blue,
                                                    // textAlign: 'center',
                                                    // paddingHorizontal: moderateScale(4)

                                                    textDecorationLine: ('underline'),
                                                    textDecorationColor: Colors.blue,

                                                }}/>


                                </TouchableOpacity>
                            }


                            }
                            // numColumns={3}

                            // horizontal={true}
                            showsHorizontalScrollIndicator={false}
                            keyExtractor={(item, index) => index.toString()}
                            //inverted={true}
                        />
                        <View style={{
                            height: moderateScale(1),
                            width: "60%",
                            marginVertical: moderateScale(14),
                            alignSelf: 'center',
                            backgroundColor: Colors.light43
                        }}/>

                        <HMTextView

                            text={this.state.item && this.state.item.address ? this.state.item.address : "دفتر مرکزی اراک، خیابان شهید رجائی (ملک)\n" + "خیابان جنت، کوچه واعظ زاده، ساختمان ساتیا"}
                            type={"bold"}
                            style={{
                                color: Colors.colorDarkText,
                                marginHorizontal: moderateScale(8),
                                fontSize: moderateScale(13),
                                // lineHeight: moderateScale(14) * moderateScale(0.75),
                                //  paddingTop: (moderateScale(14) + (moderateScale(14) / 2)) - (moderateScale(14) * moderateScale(0.75)),
                                //marginTop: moderateScale(2),
                                //  backgroundColor:Colors.blue,
                                // textAlign: 'center',
                                // paddingHorizontal: moderateScale(4)

                                // textDecorationLine: ('underline'),
                                // textDecorationColor: Colors.blue,

                            }}
                            styleRoot={{alignSelf: 'center'}}
                        />
                        <TouchableOpacity
                            style={{alignSelf: 'center', marginTop: moderateScale(4)}}
                            onPress={() => {
                                NavigationService.navigateParams("ShowMap", {
                                    showPlace: true,
                                    position: {
                                        coords: {
                                            latitude: this.state.item && this.state.item.latitude ? this.state.item.latitude : "34.084689",
                                            longitude: this.state.item && this.state.item.longitude ? this.state.item.longitude : "49.688906"
                                        }
                                    }
                                })
                            }}
                        >
                            <HMIcon name={"md-pin"} style={{
                                color: colorPrimary,
                                fontSize: moderateScale(24),
                                //padding:moderateScale(4),
                                // alignSelf: "center",
                            }}/>
                        </TouchableOpacity>
                    </View>
                </ScrollView>
            </View>

        );


    }


}


